export const setFiles = (payload) => ({
    type: 'SET_FILES',
    payload
});


// WEBPACK FOOTER //
// ./frontEnd/covid/permiso-unico-colectivo/actions/index.js